namespace GeniuzPOS.PosShift {
    export class PsVatRefundPrintingParaColumns {
        static columnsKey = 'PosShift.PsVatRefundPrintingPara';
    }
}
